export default function Thanks(){
  // console.log('========email=======', email)
  return (
    <div className="onboarding_thanks">
      <div>
        <img src='https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExMjd3b2N2aGVsN2NjcHNoem5wcWo5bnlwYTdyNTdndG9yNXV6YXJxMSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/5GoVLqeAOo6PK/giphy.gif' alt='logo' width='40%' />
      </div>
      <h2 style={{marginBottom:'20px'}}>Thanks for signing up! You'll receive your first news brief by the next business day, so be sure to keep an eye on your inbox.</h2>
      <h2 style={{marginBottom:'20px'}}>Can't wait for you to dive in and get informed, entertained, and occasionally bewildered. The future is bright, and it's about to land in your inbox.</h2>
      <p>Questions or suggestions? Email us at <a href="mailto:hello@clientintel.io">hello@clientintel.io</a></p>
    </div>
  )
}